<template>
  <FooterWrapper class="footer" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import FooterWrapper from "../../../../components/FooterWrapper.vue";

export default defineComponent({
  name: "FooterSubsection",
  components: {
    FooterWrapper
  }
});
</script>

<style>
.footer {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  left: unset !important;
  top: unset !important;
  width: 100% !important;
}
</style>
